import(/* webpackMode: "eager" */ "/vercel/path0/apps/admin/app/(root)/layout.tsx");
